import useSWR from "swr";

import salesDashboardService from "@/services/sales-dashboard.service";

export interface UseGetOrderCountProps {
  startDate: string;
  endDate: string;
}

export type UseGetOrderCountReturn = {
  data: {
    currentPeriodOrderCount: number;
    previousPeriodOrderCount: number;
    percentageIncrease: number;
  } | null;
  isLoading: boolean;
  error: Error | null;
};

const useGetOrderCount = ({
  startDate,
  endDate,
}: UseGetOrderCountProps): UseGetOrderCountReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR(
    ["getOrderCount", startDate, endDate],
    () => salesDashboardService.orderCount(startDate, endDate),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetOrderCount;
